import BookinManagementTable from './BookingManagementTable';
import BookingManagementCard from './BookingManagementCard';
import { FC, useState } from 'react';
import { Booking } from '../models';
import { I18N, LIST_VIEW } from 'src/shared/constants/constants';
import CustomDeleteModal from 'src/shared/modals/CustomDeleteModal';
import { useTranslation } from 'react-i18next';
import { VIEW_TYPE } from '../utils/utils';

interface UserManagementViewProps {
  className?: string;
  handleEditIconClick: (row: any) => void;
  handleViewIconClick: (row: any) => void;
  handleDeleteIconClick: (row: any) => void;
  handleSwitchIconClick(email: any): void;
  inputUserData: Booking[];
  inputSelectedTab: string;
  inputLoginUserRole: string;
  viewType: string;
}

const BookingManagementView: FC<UserManagementViewProps> = ({
  handleEditIconClick,
  handleViewIconClick,
  handleDeleteIconClick,
  handleSwitchIconClick,
  inputUserData: inputBookingData,
  inputLoginUserRole,
  inputSelectedTab,
  viewType
}) => {
  const [deleteDialogDetails, setDeleteDialogDetail] = useState();
  const { t } = useTranslation(I18N.BOOKING_MANAGEMENT);
  const handleDeleteIconClickEvent = (details) =>
    setDeleteDialogDetail(details);
  const confirmDelete = () => {
    handleDeleteIconClick(deleteDialogDetails);
    setDeleteDialogDetail(null);
  };
  return (
    <>
      {/* user managnement table */}
      {viewType == VIEW_TYPE.BOOKING_MANAGEMENT && (
        <>
          {inputSelectedTab === LIST_VIEW.CARD_VIEW ? (
            <BookingManagementCard
              inputBookingData={inputBookingData}
              handleEditIconClick={handleEditIconClick}
            />
          ) : (
            <BookinManagementTable
            inputBookingData={inputBookingData}
           
            handleViewIconClick={handleViewIconClick}
              inputLoginUserRole={inputLoginUserRole}
              handleEditIconClick={handleEditIconClick}
              handleDeleteIconClick={handleDeleteIconClickEvent}
              handleSwitchIconClick={handleSwitchIconClick}
            />
            
          )}
          
        </>
      )}

      <CustomDeleteModal
        open={deleteDialogDetails ? true : false}
        title={
          viewType == VIEW_TYPE.BOOKING_MANAGEMENT
            ? t('dialog.delete.user.title')
            : t('dialog.delete.user.title')
        }
        subtitle={
          viewType == VIEW_TYPE.BOOKING_MANAGEMENT
            ? t('dialog.delete.assets.subtitle')
            : t('dialog.delete.assets.subtitle')
        }
        details={deleteDialogDetails}
        nameKey={viewType == VIEW_TYPE.BOOKING_MANAGEMENT ? 'email' : 'name'}
        onDelete={confirmDelete}
        onClose={() => setDeleteDialogDetail(null)}
      />
    </>
  );
};

export default BookingManagementView;
